import { render, staticRenderFns } from "./AiOptimizePhrasing.vue?vue&type=template&id=091c034b&scoped=true"
import script from "./AiOptimizePhrasing.vue?vue&type=script&lang=js"
export * from "./AiOptimizePhrasing.vue?vue&type=script&lang=js"
import style0 from "./AiOptimizePhrasing.vue?vue&type=style&index=0&id=091c034b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091c034b",
  null
  
)

export default component.exports